import {vnTemplate} from "./vnTemplate";

declare var ko: any;

export class menu_collapsible_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
            <ul data-bind="foreach: menus" class="main-nav-list  main-nav-drop">
            	<li class="main-nav-item " data-bind="css: { 'dropdown': subMenus().length > 0 }, attr: {id: 'li-' + identifier}">
            		<a data-bind="attr: {id: 'href-' + identifier, href: subMenus().length > 0 ? 'javascript:void(0)' : url,class: 'main-nav-link icon' + $data.cssClass}, css: { 'is-selected': selected, 'dropdown-toggle': subMenus().length > 0 }, event: { mousedown: $parent.menuClick }">
            		    <span data-bind="text: text"></span>
                    </a>            	
            		<ul data-bind="visible: subMenus().length, foreach: subMenus" class="dropdown-list main-nav-drop">
            		    <li class="dropdown" data-bind="attr: {id: 'li-' + $data.identifier}">
            		        <a data-bind="attr: {id: 'href-' + $data.identifier, href: $data.url, class: 'dropdown-link dropdown-toggle icon ' + $data.cssClass}, css: {'dropdown-toggle': 'subMenus' in $data }, event: { mousedown: $parents[1].menuClick }">
            		            <span data-bind="text:  $data.text"></span>
                            </a>
                            <!-- ko if: "subMenus" in $data -->
                            <ul data-bind="visible: subMenus.length, foreach: subMenus" class="dropdown-list  main-nav-drop">
                                <li>
                                    <a data-bind="text: $data.text, attr: {href: $data.url, class: 'dropdown-link icon ' + $data.cssClass}, event: { mousedown: $parents[2].menuClick.bind($data, $parents[1], $data) }"></a>
                                </li>
                            </ul>
                            <!-- /ko -->
                        </li>
                    </ul>
            	</li>
            </ul>
            `;
    }

    protected getTemplateName(): string{
        return "menu-collapsible-template";
    }
    protected getMainElementType(): string{
        return "nav";
    }
    protected getMainElementClasses(): Array<string>{
        return ["main-nav"];
    }

    protected buildViewModel(): any{
        let self = this;

        return {
            menus: ko.observableArray([]),
            menuClick: function(menu, event){ self.menuClick(menu, event); }
        };
    }

    menuClick(menu, event){

        if(menu.level == 1) {
            menu.selected(!menu.selected());

            let defaultSectionId = this.caller.getDefaultSectionId();
            if (menu.idSection == defaultSectionId) {
                this.caller.resetGlobalSelectedBrandMenuPage();
            }

            this.caller.handleActiveMenus(menu);
        }else{

            this.caller.setGlobalSelectedBrandMenuPage(menu.id);
        }

        return true;
    }


    setMenus(menus): void{

        let sp = this.caller.getGlobalSelectedBrandMenuPage();
        let menusArray = [];
        let actives = this.caller.getActiveMenus();
        for( let m of menus ){
            let n = {id: null, identifier: null, text: "", url: "", idSection: null, selected: true, subMenus: [], cssClass: "", level: 1};
            n.id = m.id;
            n.identifier = 'identifier-1-' + m.id
            n.text = ko.observable(m.text);
            n.selected = ko.observable((actives.indexOf(m.id) != -1));
            n.idSection = m.idSection;
            n.url = m.url;
            m.subMenus.forEach((sm) => {
                sm['identifier'] = 'identifier-2-' + sm.id
                sm['cssClass'] = (sm['cssClass'].length > 0) ? " " + sm['cssClass'].join(" ") : '';
                sm['cssClass'] += (sm.id == sp) ? 'is-selected': '';
                sm['level'] = 2;
            });
            n.subMenus = ko.observable(m.subMenus);
            n.cssClass = (m.cssClass.length > 0) ? " " + m.cssClass.join(" ") : "";

            menusArray.push(n);
        }


        this.getTemplateViewModel().menus(menusArray);
    }

    public getMenus() {
        return this.getTemplateViewModel().menus();
    }

}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/menu_collapsible_template.ts